module.exports = __webpack_public_path__ + "static/media/https_24px_rounded.8859a615.svg";